import * as React from "react";

function SvgKevel(props, ref) {
  return (
    <svg
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 33 49"
      width="1em"
      height="1em"
      {...{ ...props, ref }}
    >
      <path fill="none" d="M0 0h136v49H0z" />
      <path fill="none" d="M136 0v49H0V0z" />
      <path
        d="M11 .766v19.625a2.358 2.358 0 01-3.527 1.994l-6.285-3.5A2.286 2.286 0 010 16.891V.766A.776.776 0 01.786 0h9.428A.776.776 0 0111 .766zM7.473 26.615l-6.285 3.5A2.286 2.286 0 000 32.109v16.125A.776.776 0 00.786 49h9.428a.776.776 0 00.786-.766V28.609a2.358 2.358 0 00-3.527-1.994z"
        fill="#d52e14"
      />
      <path
        d="M1.246 30.786L11 28.609v11.883l-9.829-8.037C.654 32.031.012 32.226 0 32.8v-.694c0-.914 1.246-1.32 1.246-1.32zm-.075-14.241C.654 16.969.012 16.774 0 16.2v.694c0 .917 1.246 1.323 1.246 1.323L11 20.391V8.508z"
        fill="#ad0600"
      />
      <path
        d="M33 37.79v10.042a.786.786 0 01-1.176.665L1.175 31.431A.785.785 0 000 32.083a2.242 2.242 0 01.32-1.128 2.32 2.32 0 01.868-.84L9.831 25.3a2.407 2.407 0 012.338 0l20.039 11.161A1.523 1.523 0 0133 37.79zM31.824.5L1.175 17.569A.785.785 0 010 16.917a2.242 2.242 0 00.32 1.128 2.32 2.32 0 00.868.84L9.831 23.7a2.407 2.407 0 002.338 0l20.039-11.161A1.523 1.523 0 0033 11.21V1.168A.786.786 0 0031.824.5z"
        fill="#fd563c"
      />
    </svg>
  );
}

export default React.forwardRef(SvgKevel);
